// Connection url
export const DEV_SERVER_URL = 'http://localhost:62531/api/'; // URL local
// export const PRODUCTION_SERVER_URL = 'https://bmtest.leaseplan.pt/GCF/WebAPI/api/'; // URL for LP1002 quality
export const PRODUCTION_SERVER_URL = 'https://bm.ayvens.pt/GCF/WebAPI/api/'; // URL for LP1002 production
// export const PRODUCTION_SERVER_URL = 'http://leaseplan.armis.pt/GCF/WebAPI/api/'; // URL for leaseplan.armis.pt QUAL Environment

export const DEV_FRONTEND_SERVER_URL = 'http://localhost/'; // URL local
// export const PRODUCTION_FRONTEND_SERVER_URL = 'https://bmtest.leaseplan.pt/'; // URL for LP1002 quality
export const PRODUCTION_FRONTEND_SERVER_URL = 'https://bm.ayvens.pt/'; // URL for LP1002 production

//Brand types
export const NEW_CARS_BRANDS = 0;
export const USED_CARS_BRANDS = 1;
export const ALL_CAR_BRANDS = 2;
//Table basics
export const STARTING_TABLE_PAGE = 0;
export const AVAILABLE_CARS_ROWS_PER_PAGE = 10;
export const DEFAULT_ROWS_PER_PAGE = 25;
export const NO_TABLE_DATA_MESSAGE = 'Sem dados para apresentar.';
//Ordering
export const ORDER_BY_EXPIRATION_DATE = 'expirationdate';
export const ORDER_BY_RESERVATION_DATE = 'reservationdate';
export const ORDER_BY_BRAND = 'brand';
export const ORDER_BY_DESCRIPTION = 'description';
export const ORDER_BY_BRAND_DESCRIPTION = 'branddescription';
export const ORDER_BY_COLOR = 'color';
export const ORDER_BY_OPTIONAL_ORDER = 'order';
export const ORDER_ASCENDING = 'asc';
export const ORDER_DESCENDING = 'desc';
//Lot Phase
export const NEGOTIATION_PHASE = 1;
export const FP_PHASE = 2;
export const FINISHED_PHASE = 3;
export const UR_PHASE = 5;
//Module Name
export const FP_MODULE = 'CF';
export const UR_MODULE = 'RU';
//Reservation Types
export const EFECTIVE_RESERVATION_ID = 1;
export const ON_HOLD_RESERVATION_ID = 2;
//Report Ids
export const REPORT_GLOBAL_STOCK = 1;
export const REPORT_COMMERCIAL_STOCK = 2;
export const REPORT_RESERVATIONS_BY_STATE = 3;
export const REPORT_ACTIVE_RESERVATIONS = 4;
export const REPORT_NOLS = 5;
//AD Groups
export const ADMIN_GROUP = 1;
export const FP_NEGOTIATION_GROUP = 2;
export const FP_GROUP = 3;
export const FP_COMMERCIAL_GROUP = 4;
export const REPORTS_GROUP = 5;
export const REPORTS_GLOBAL_GROUP = 6;
export const GENERAL_GROUP = 7;
export const UR_CREATION_GROUP = 8;
export const UR_GROUP = 9;
export const UR_COMMERCIAL_GROUP = 10;
export const UR_GENERAL_GROUP = 11;
//UI Messages
export const LOT_SAVE_SUCCESS = 'Lote editado com sucesso!';
//Admin Table Header
export const ADMIN_TABLE_HEADER = [
  { id: 'id', label: 'ID' },
  { id: 'description', label: 'DESCRITIVO' },
  { id: 'deleted', label: 'ATIVO' }
];
//Other
export const RAPPEL_INITIAL_VALUE = 4;
export const RESERVATION_TABLE_RELOAD_TIMER = 60000;
export const CHECK_LOGIN_TIMER = 1500; // 1.5 SECONDS
//Audit Tables
export const AUDIT_BMSF = 'BMSF';
export const AUDIT_SFBM = 'SFBM';
//Special Characters
export const SPECIAL_CHARACTERS_INPUT = /[<{}[\]!@$?^]/gi;
//Font Family
export const FONT_FAMILY_TYPOGRAPHY = {
    'fontFamily': '\'Roboto\', \'Arial\', \'Helvetica\', sans-serif',
    'fontWeightLight': 300,
    'fontWeightRegular': 400,
    'fontWeightMedium': 500,
}


// WEBPACK FOOTER //
// ./src/Utils/Constants.js